import gql from 'graphql-tag';
import ContentFields from '../fragments/content';

export default gql`
  query recentContent(
    $limit: Int!
    $offset: Int!
  ) {
    recentContent(
      limit: $limit
      offset: $offset
    ) {
      ...ContentFields
    }
  }
  ${ContentFields}
`;
